import { computed, effect, inject, Injectable, OnInit, signal, untracked, WritableSignal } from "@angular/core";
import { Select, SelectCode } from "@corporate-tailwind/model";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class CorpTranslateService {
private _translateService = inject(TranslateService);

private signals: WritableSignal<any>[] = [];
private readonly _lang: WritableSignal<string>;
public readonly lang$;

  constructor() {
    this._lang = signal(this._translateService.getCurrentLang());
    this.lang$ = this._lang.asReadonly();

    this._translateService.onLangChange.subscribe(event => {
        this._lang.set(event.lang);
        this.refreshSignals();
    });
  }

  attach<T>(signal: WritableSignal<T>) {
    this.signals.push(signal);
    // traduction initiale
    signal.set(this.translate(signal()));
  }

  private refreshSignals() {
    this.signals.forEach(signal => {
      signal.set(this.translate(signal()));
    });
  }

  translate<T>(data: T): T {
    if (!data) return data;

    const copy = structuredClone(data);
    return this.translateRecursive(copy);
  }

  //fourni un select pour traduction dans le back end
  getBackEndTranslation(i18n: string) : SelectCode {
    //derniere chaine apres . du i18n
    const code = i18n.split('.').pop()?.toUpperCase();
    const label = this._translateService.instant(i18n);
    return { 'id': null, 'code': code, 'label': label, labelLCode: null } as SelectCode;
  }
  
  private translateRecursive(obj: any): any {
    
    if (Array.isArray(obj)) {
        var result = obj.map(v => this.translateRecursive(v));
  
        return result;
    //   return obj.map(v => this.translateRecursive(v));
    }

    if (obj && typeof obj === 'object') {
   
      Object.keys(obj).forEach(key => {
        const value = obj[key];

        if (value && typeof value === 'object') {
          obj[key] = this.translateRecursive(value);
        }

        if (key.endsWith('LCode')) {
          const baseKey = key.slice(0, -5);
          if (baseKey in obj && value!=null) {
            obj[baseKey] = this._translateService.instant(`${value}`);
          }
        }
      });

    }

    return obj;
  }
}
